import { createSlice } from '@reduxjs/toolkit';

import {
  getDailyChallenges,
  getSchoolDailyChallenges,
  updateDailyChallengeInListById,
  removeDailyChallengeById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const dailyChallengesSlice = createSlice({
  name: 'dailyChallenges',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getDailyChallenges.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(
      getSchoolDailyChallenges.fulfilled,
      (_: any, action: any) => {
        return action.payload;
      },
    );

    builder.addCase(
      updateDailyChallengeInListById.fulfilled,
      (state: any, action: any) => {
        const { fieldName, updatedDailyChallenge } = action.payload;

        return {
          ...state,
          data: state.data.map((item: any) => {
            if (item.id === updatedDailyChallenge.id) {
              return {
                ...item,
                [fieldName]: updatedDailyChallenge[fieldName],
              };
            }

            return item;
          }),
        };
      },
    );

    builder.addCase(removeDailyChallengeById, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter((item: any) => item.id !== action.payload),
      };
    });
  },
});

export default dailyChallengesSlice.reducer;
